var map = {
	"./1.11 CG-Research-Centre.jpg": 3686,
	"./1.12 CG-Research-Centre.jpg": 2552,
	"./1.13 CG-Research-Centre.png": 5219,
	"./1.14 CG-Research-Centre.jpg": 8742,
	"./2.11 CG-Research-Centre.jpg": 1964,
	"./2.12 CG-Research-Centre.jpg": 5117,
	"./2.13 CG-Research-Centre.jpg": 2028,
	"./2.14 CG-Research-Centre.png": 7821
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2059;